export default __webpack_public_path__ + "static/media/4.9582ff96.png";